import Vue from 'vue';
import Router from 'vue-router';

// Lazy loading components
const ActiveDirectoryLogin = () => import(/* webpackChunkName: "ActiveDirectoryLogin" */ './components/Login/ActiveDirectoryLogin.vue');
const Help = () => import(/* webpackChunkName: "Help" */ '@/views/Help.vue');
const Forbidden = () => import(/* webpackChunkName: "Forbidden" */ './views/Forbidden.vue');
const Home = () => import('./views/Home.vue');
const Orders = () => import('./views/Orders.vue');
const OrderDetail = () => import('./views/OrderDetail.vue')
const Clients = () => import(/* webpackChunkName: "Clients" */ './views/Clients.vue');
const EpAttorney = () => import('./views/EpAttorney.vue');
const ProcessingType = () => import('./views/ProcessingType.vue');
const Users = () => import('./views/Users.vue');
const Download = () => import('./views/Download.vue');
const DownloadSoftware = () => import('./views/DownloadSoftware.vue');
const DownloadDocumentation = () => import('./views/DownloadDocumentation.vue');
const DownloadOptOutDocument = () => import('./views/DownloadOptOut.vue');

import { NotFound } from '@questelservices/common-vue';
import { getModule } from 'vuex-module-decorators';
import store from './store';
import CommonModule from '@questelservices/common';
import UserModule from '@/modules/UserModule';

const productName: string = 'QuestelServicesUnitaryPatentService';
const commonState: CommonModule = getModule(CommonModule, store);
const userModule: UserModule = getModule(UserModule, store);

/*  Preventing "NavigationDuplicated" errors in console in Vue-router >= 3.1.0
    https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378 */

const routerMethods: Array<string> = ['push', 'replace'];

routerMethods.forEach((method: string) => {
    const originalCall = (Router.prototype as any)[method];

    (Router.prototype as any)[method] = function (location: any, onResolve: any, onReject: any): Promise<any> {

        if (onResolve || onReject) {
            return originalCall.call(this, location, onResolve, onReject);
        }

        return (originalCall.call(this, location) as any)
            .catch((err: any) => {
                return err;
            });
    };
});

const postADLogoutRedirectUrl = window.location.origin + '/employee';

commonState.setPostADLoginRedirectUrl(postADLogoutRedirectUrl);

Vue.use(Router);

export const routes = [
  {
    path: '/',
    name: 'home',
        meta: { requiresAuth: true },
    redirect: () => { return { path: '/orders' } }
  },
  {
    path: '/orders',
    name: 'orders',
      meta: { requiresAuth: true },
    components: {
      content: Orders
    }
  },
  {
    path: '/orders/:order_id',
    name: 'orderDetails',
      meta: { requiresAuth: true },
    components: {
      content: OrderDetail
    }
  },
  {
    path: '/clients',
    name: 'clients',
      meta: { requiresAuth: true },
    components: {
      content: Clients
    }
    },
    {
        path: '/downloadSigner',
        name: 'downloadSoftware',
        meta: { requiresAuth: true },
        components: {
            content: DownloadSoftware
        }
    },
    {
        path: '/downloadOptOut/:token',
        name: 'downloadOptOut',
        meta: { requiresAuth: true },
        components: {
            content: DownloadOptOutDocument
        }
    },
    {
        path: '/downloadDocumentation',
        name: 'downloadDocumentation',
        meta: { requiresAuth: true },
        components: {
            content: DownloadDocumentation
        }
    },
  {
    path: '/employee',
    name: 'employee',
    meta: { requiresAuth: false, title: 'Login' },
    components: {
      content: ActiveDirectoryLogin
    },
    props: {
      content: { productName: productName, logoPath: './img/questel-logo.png' },
      redirectUrl: '/'
    }
  },
  {
    name: 'help',
    path: '/help',
    meta: {
      requiresAuth: true,
      breadcrumbs: [{ text: 'Help' }]
    },
    components: {
      content: Help
    }
    },

  {
    name: 'forbidden',
    path: '/forbidden',
    meta: {
      requiresAuth: true,
      breadcrumbs: []
    },
    components: {
      content: Forbidden
    }
  },
  // note: As routing is handled in the SPA a HTTP 404 is not sent by the server.
  {
    path: '*',
    name: 'NotFound',
    meta: { requiresAuth: true },
    components: {
      content: NotFound
    }
  },
    {
        path: '/ReceiptDownload/:token',
        name: 'ReceiptDownload',
        meta: { requiresAuth: false },
        components: {
            content: Download
        }
    }
];

const router: any = new Router({
    mode: 'history',
    routes
});

router.beforeEach(async (to: any, from: any, next: any) => {

  document.title = to.meta.title || 'Questel - Unitary Patent';
  if(commonState.authenticatedUser.authenticated && (to.name && to.name.toLowerCase() === 'home')) {
    next({ path: '/orders' });
    return;
  }
  /**
   * ADD VUEX RESETS HERE WHEN GOING BACK TO LOGIN
   */
  if ((to.name === 'employee' && !commonState.authenticatedUser.authenticated)) {
    userModule.reset();
  }

    if (to.matched.some((record: { meta: { requiresAuth: boolean } }) => record.meta.requiresAuth)) {
        if (!commonState.authenticatedUser.authenticated) {
            let nextTarget: string = 'employee';
            let codeQuery: any = { redirect: to.fullPath };

            next({
                name: nextTarget,
                query: codeQuery
            });

        } else {
            next();
        }

    } else {
        next();
    }
});

export default router;

